import React from 'react';
import { Box, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PublisherLogo from '../../components/publisherLogo';

const card = {
    background: 'linear-gradient(180deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.015) 100%)',
    border: '1px solid rgba(187,188,188,0.14)',
    borderRadius: '22px',
    padding: '20px',
    mt: 2,
};

const recLink = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.25,
    width: '100%',
    py: 0.625,
    px: 0.75,
    borderRadius: '12px',
    background: 'transparent',
    border: '1px solid transparent',
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'background 0.18s ease, border-color 0.18s ease',
    '&:hover': {
        background: 'rgba(0,120,255,0.10)',
        borderColor: 'rgba(0,215,255,0.30)',
    },
    '& .chev': {
        color: 'var(--ecal-midgrey)',
        transition: 'color 0.18s ease, transform 0.18s ease',
    },
    '&:hover .chev': {
        color: 'var(--ecal-lightblue)',
        transform: 'translateX(2px)',
    },
};

function SidebarRecommended({ publishers = [], onSync }) {
    function renderPublisher(p) {
        return (
            <Box
                key={p.id || p.pubId}
                component="button"
                onClick={() => onSync && onSync(p)}
                aria-label={`Sync ${p.name} to your calendar`}
                sx={recLink}
            >
                <PublisherLogo logo={p.logo} name={p.name} logoColors={p.logoColors} size={32} />
                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography sx={{ fontSize: '0.875rem', fontWeight: 500, color: 'var(--ecal-white)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {p.name}
                    </Typography>
                    <Typography sx={{ fontSize: '0.6875rem', color: 'var(--ecal-lightgrey)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {p.industries?.[0]}
                    </Typography>
                </Box>
                <ChevronRightIcon className="chev" sx={{ fontSize: 16 }} />
            </Box>
        );
    }

    return (
        <Box sx={card}>
            <Typography sx={{ fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ecal-lightgrey)', mb: 1.5 }}>
                Recommended for you
            </Typography>
            {publishers.length === 0 ? (
                <Typography sx={{ fontSize: '0.72rem', color: 'var(--ecal-midgrey)' }}>
                    No recommendations right now — you're all caught up.
                </Typography>
            ) : (
                publishers.map(renderPublisher)
            )}
        </Box>
    );
}

export default SidebarRecommended;
